/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@packages/api-client/client-config";
import type { GetSubscriptionQueryResponse, GetSubscriptionPathParams, GetSubscription400, GetSubscription401, GetSubscription403, GetSubscription404, GetSubscription409, GetSubscription500 } from "../../types/platformBillingController/GetSubscription.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";

function getGetSubscriptionUrl(organizationId: GetSubscriptionPathParams["organizationId"]) {
  const res = { method: 'GET', url: `/api/organizations/${organizationId}/platform-billing/subscription` as const }
  return res
}

/**
 * @summary Get current subscription
 * {@link /api/organizations/:organizationId/platform-billing/subscription}
 */
export async function getSubscription(organizationId: GetSubscriptionPathParams["organizationId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetSubscriptionQueryResponse, ResponseErrorConfig<GetSubscription400 | GetSubscription401 | GetSubscription403 | GetSubscription404 | GetSubscription409 | GetSubscription500>, unknown>({ method : "GET", url : getGetSubscriptionUrl(organizationId).url.toString(), ... requestConfig })
  return res.data
}